exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spanreg[data-v-3d099cca]{padding:3px 10px 3px 3px;border-radius:6px}.is-select[data-v-3d099cca]{background-color:#5a5a5a;color:#fff}.has-text-warning[data-v-3d099cca]{color:#e6b800!important}.has-text-grey[data-v-3d099cca]{color:#aeaeae!important}.datospruducto table[data-v-3d099cca],.datospruducto td[data-v-3d099cca],.datospruducto th[data-v-3d099cca]{font-size:14px;padding-left:3px!important;padding-right:3px!important;color:#8b8b8b!important}.datospruducto tfoot[data-v-3d099cca]{border:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d099cca","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/facturar/componentsfra/Viewitems2.vue
// module id = 739
// module chunks = 0